export const Minutes = Array.from(['00', '15', '30', '45'], (i) => { return { id: i, name: i }; });

export default Minutes;



// WEBPACK FOOTER //
// ./src/views/StaticData/Minutes.tsx